import { render } from "./publish_date.vue?vue&type=template&id=00f6603c&lang=pug"
import script from "./publish_date.vue?vue&type=script&lang=js"
export * from "./publish_date.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__